import React from "react";

export const EmotionKeywords = React.lazy(
  () => import("@/features/emotion-keywords/pages/EmotionKeywordsPage.tsx"),
);
